import Loader from 'components/common/Loader';
import styled from 'styled-components';
import {useCustomTheme} from 'context/customTheme';

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ViewLoader = () => {
  const {finalTheme} = useCustomTheme();
  const {colors} = finalTheme;

  return (
    <LoadingWrapper>
      <Loader color={colors.branding.primary} width={60} height={60} />
    </LoadingWrapper>
  );
};
